import { Box, Flex, Text } from '@chakra-ui/react';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@morressier/alembic';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import FileViewerButtonText from './FileViewerButtonText';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';

const ShowAttachementFiles = ({
  attachments,
  onClose
}: {
  attachments?: ISubmissionFile[];
  onClose: () => void;
}) => {
  const { submissionContextId } = useSubmissionData();

  return (
    <div>
      <Modal isOpen onClose={onClose} width="45rem">
        {!!attachments?.length && (
          <Box marginTop={4} padding={4}>
            <Text textStyle="headingItem">
              Attached files ({attachments?.length})
            </Text>
            <Flex flexDirection="column" marginTop={2} gap={2}>
              {(attachments ?? []).map(attachment => (
                <Flex
                  justifyContent="space-between"
                  key={attachment?.referenceName}
                  padding={2}
                  borderTop={'1px'}
                  borderColor="neutralPrimaryBorder"
                >
                  <Flex gap={2} alignItems="center">
                    <FontAwesomeIcon icon={faFile} />
                    <Text textStyle="textBody">
                      {attachment?.referenceName}
                    </Text>
                    <FileViewerButtonText
                      file={attachment}
                      submissionContextId={submissionContextId}
                    >
                      View
                    </FileViewerButtonText>
                  </Flex>
                </Flex>
              ))}
            </Flex>
          </Box>
        )}
      </Modal>
    </div>
  );
};
export default ShowAttachementFiles;
